import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    input: {
      width: '100%',
      margin: theme.spacing(1, 0),
      padding: 0,
    },
    buttons: {
      width: '100%',
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'end',
      gap: '1.6rem',

      '& > button': {
        width: '10rem',
        margin: 0,
      },
    },
    passwordChanged: {
      height: '20rem',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',

      '& > p': {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& > button': {
        width: '8rem',
        margin: 0,
        alignSelf: 'end',
      },
    },
  }),
)
